import React from "react";

import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import { GoHome, } from "react-icons/go";
import { GoHomeFill } from "react-icons/go";
import { TbUserSquare } from "react-icons/tb";
import { PiPassword, PiUserFill, PiPasswordFill } from "react-icons/pi";
import { FaRegUser } from "react-icons/fa6";
import { IoShieldCheckmarkOutline } from "react-icons/io5";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { MdBlockFlipped } from "react-icons/md";
import { FaPhoneVolume } from "react-icons/fa6";
import { PiChatCircleText } from "react-icons/pi";
import { BsEmojiSmile } from "react-icons/bs";
import { TbPhoneCall } from "react-icons/tb";
import { SlBell } from "react-icons/sl";
import { RiShoppingBagLine } from "react-icons/ri";
import { BsExclamationOctagon } from "react-icons/bs";
import { PiUsersThree } from "react-icons/pi";
import { MdOutlineHeadphones } from "react-icons/md";
import { MdOutlineLeaderboard } from "react-icons/md";
import { VscFeedback } from "react-icons/vsc";
import { TbFileCertificate } from "react-icons/tb";

// import { IoShieldCheckmarkOutline } from "react-icons/io5";

import skillicon from "../../assets/images/skillicon.png";
import skilliconActive from "../../assets/images/VectorActive.png";
import Commission from "../../assets/images/commition.png";
import CommissionActive from "../../assets/images/commitionactive.png";
import cmsicon from "../../assets/images/cmsicon.png"
import cmsiconactive from "../../assets/images/cmsactive.png"
import payment from "../../assets/images/paymentInactive.png"
import paymentactive from "../../assets/images/paymentActive.png"

export const SidebarData = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: <GoHome />,
    activeIcon: <GoHomeFill />, // Add active icon here
  },
  {
    title: "User Management",
    path: "/userManagement",
    icon: <FaRegUser />,
    activeIcon: <FaRegUser />,
    iconClosed: <IoIcons.IoIosArrowDown />,
    iconOpened: <IoIcons.IoIosArrowUp />,
    subNav: [
      {
        title: "Approved Users",
        path: "/userManagement",
        icon: <IoShieldCheckmarkOutline />,
      },
      {
        title: "Registration Requests",
        path: "/registrationRequest",
        icon: <IoIosInformationCircleOutline />,
      },
      {
        title: "Certificate Requests",
        path: "/certificateRequest",
        icon: <TbFileCertificate />,
      },
    ],
  },
  {
    title: "Skill Management",
    path: "/skillsManagement",
    icon: <img src={skillicon} style={{ height: "1.3rem" }} />,
    activeIcon: <img src={skilliconActive} style={{ height: "1.3rem" }} />,
  },
  {
    title: "Blacklist Word Management",
    path: "/blockManagement",
    icon: <MdBlockFlipped />,
  },
  {
    title: "Commission Management",
    path: "/commissionSettings",
    icon: <img src={Commission} style={{ height: "1.3rem" }} />,
    activeIcon: <img src={CommissionActive} style={{ height: "1.3rem" }} />,
  },

  {
    title: "Gigs Management",
    path: "/gigsManagement",
    icon: <RiShoppingBagLine />,
  },

  {
    title: "Reported Gig Management",
    path: "/reportedGigManagement",
    icon: <BsExclamationOctagon />,
  },

  {
    title: "Leader board",
    path: "/leaderboardManagement",
    icon: <MdOutlineLeaderboard />,
  },

  {
    title: "Sub Admin Management",
    path: "/subAdminManagement",
    icon: <PiUsersThree />,
  },

  {
    title: "CMS Management",
    path: "/cmsManagement",
    icon: <img src={cmsicon} />,
    activeIcon: <img src={cmsiconactive} style={{ height: "1.4rem" }} />,
    iconClosed: <IoIcons.IoIosArrowDown />,
    iconOpened: <IoIcons.IoIosArrowUp />,
    subNav: [
      {
        title: "Privacy Policy",
        path: "/cmsManagement",
        icon: <IoShieldCheckmarkOutline />,
      },
      {
        title: "About Us",
        path: "/aboutUs",
        icon: <BsEmojiSmile />,
      },
      {
        title: "Contact Us",
        path: "/contactUs",
        icon: <TbPhoneCall />,
      },
      {
        title: "Terms & Conditions",
        path: "/terms&Conditions",
        icon: <IoIosInformationCircleOutline />,
      },
      {
        title: "FAQs",
        path: "/fAQs",
        icon: <PiChatCircleText />,
      },
    ],
  },

  {
    title: "Payment Management",
    path: "/paymentManagement",
    icon: <img src={payment} style={{ height: "1rem" }} />,
    activeIcon: <img src={paymentactive} style={{ height: "1rem" }} />,
  },

  {
    title: "Ticket Management",
    path: "/ticketManagement",
    icon: <MdOutlineHeadphones />,
  },

  {
    title: "Notification Management",
    path: "/notificationManagement",
    icon: <SlBell />,
  },

  {
    title: "Feedback Management",
    path: "/feedbackManagement",
    icon: <VscFeedback />,
  },

];



export const profileSidebarData = [
  {
    title: "My Profile",
    path: "/profile",
    icon: <AiIcons.AiOutlineUser />,
    activeIcon: <PiUserFill />,
  },

  {
    title: "Change Password",
    path: "/changedPassword",
    icon: <PiPassword />,
    activeIcon: <PiPasswordFill />,
  },
];
